import { TextInput } from "react-admin";

const categoryFilterList = [
  <TextInput
    source="name"
    label="mine.label.name"
    variant="outlined"
    alwaysOn
    resettable
  />,
];

export default categoryFilterList;
